export default __webpack_public_path__ + "static/media/Scholar's Leggings of the Effulgent Blade.2bc98513.jpg";